import { Injectable } from '@angular/core';
import { NavParams, MenuController, Events } from 'ionic-angular';
import { UtilitiesProvider } from './utilities';

@Injectable()
export class MenuControl {

  constructor(
    private menuCtrl: MenuController,
    private event: Events,
    private utilities: UtilitiesProvider
  ) { }

  /**
   * Se encarga de manejar la presencia del menu durante toda la aplicacion
   * @param params
   * @param closeAll
   */
  public validateMenu(params: NavParams = null, closeAll = false) {
    if (closeAll) {
      this.menuCtrl.enable(false, 'generalMenu');
      this.menuCtrl.enable(false, 'eventMenu');
      return;
    }

    if (params) {
      if (this.utilities.validateEventId(params)) {
        this.menuCtrl.enable(false, 'generalMenu');
        this.menuCtrl.enable(true, 'eventMenu');
        this.event.publish('menuEvent', params.get('eventId'));
      } else {
        this.menuCtrl.enable(true, 'generalMenu');
        this.menuCtrl.enable(false, 'eventMenu');
      }
    } else {
      this.menuCtrl.enable(true, 'generalMenu');
      this.menuCtrl.enable(false, 'eventMenu');
    }
  }

}


// WEBPACK FOOTER //
// ./src/providers/menu.ts